import Badge from "@mui/material/Badge";
import Box from "@mui/material/Box";
import { useLocation } from "react-router-dom";
import { ThemedEditIcon } from "assets/CXFIcons/Portal/Profile";
import SoftAvatar from "components/SoftAvatar";
import ProtectedButton from "authentication/ProtectedButton";
import { PERMISSIONS } from "constants/portal";

function UploadBadge({ children, isOwner, onClick }) {
  const location = useLocation();
  const pathname = location.pathname;

  return (
    <Box sx={{ display: "flex" }}>
      <Badge
        badgeContent={
          <ProtectedButton
            permissionName={
              pathname === "/administration/company"
                ? PERMISSIONS.ACCESS_TO_COMPANY_EDIT_PAGE
                : pathname === "/account/users/profile-overview" ||
                  pathname === "/home" ||
                  pathname === "/home/profile" ||
                  pathname === "/home/settings" ||
                  pathname === "/privacy-and-security"
                ? PERMISSIONS.ACCESS_TO_USER_EDIT_PAGE
                : ""
            }
            isOwner={isOwner}
          >
            <SoftAvatar
              variant="rounded"
              shadow="sm"
              size="md"
              bgColor="light"
              sx={{
                marginLeft: "-18px",
                marginTop: "-18px",
                cursor: "pointer",
                display: "flex",
                border: "0.5px solid #e6e6e6 !important",
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1) !important"
              }}
              onClick={onClick}
            >
              <ThemedEditIcon />
            </SoftAvatar>
          </ProtectedButton>
        }
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right"
        }}
      >
        {children}
      </Badge>
    </Box>
  );
}

export default UploadBadge;